module.exports = __webpack_public_path__ + "3de10aee8cd6f344c98f06ace7941bb1.svg";